import dayjs from "dayjs";
import capitalize from "lodash/capitalize";
import { MarkerType } from "reactflow";
import { v4 as uuidv4 } from "uuid";

import { ConditionalEventType, Edge, Node, NodeTriggerType, NodeType, XYPosition } from "Types/Journey";

// move this to a shrared place. this should for eventattrobites not for journeys
export function getEventType(eventType: NodeTriggerType | ConditionalEventType) {
    // Behavior when setting event types is to default to track, so this should match.
    // (contactAddedToSegment is being grouped under track atm). Also following existing logic
    // For the contact attribute condtional type, which is currently using track. confusing maybe,
    // but seems to return the correct field names
    switch (eventType) {
        case NodeTriggerType.RegalVoice:
        case ConditionalEventType.RegalVoice:
            return "regal_voice_event";
        case NodeTriggerType.Pageview:
            return "pageview";
        default:
            return "track";
    }
}

export function triggerTypeDisplayName(t: NodeTriggerType): string {
    switch (t) {
        case NodeTriggerType.AddContactToStaticSegment:
            return "Contact Added to Static Segment";
        case NodeTriggerType.RegalVoice:
            return "Regal Voice Event";
        case NodeTriggerType.Custom:
            return "Custom Event";
        default:
            return capitalize(t);
    }
}

export function createLabeledOptions(item: Record<string, string>, prefix?: string) {
    return {
        nodeId: item.nodeId,
        value: `${prefix}.${item.value}`,
        label: `${prefix}.${item.value}`,
        displayText: item.label,
    };
}

export function prettyPrintDate(date?: Date) {
    // dayjs can accept undefined, just returns now
    return dayjs(date).format("MM/DD/YYYY hh:mm A z");
}

function initData(type: NodeType) {
    switch (type) {
        case NodeType.Trigger:
            return { triggerType: null, eventName: "" };
        case NodeType.Delay:
            return { days: null, hours: null, minutes: null, seconds: null };
        case NodeType.Call:
            return { campaign: {} };
        case NodeType.SMS:
            return { campaign: {} };
        case NodeType.AgentSMSTask:
            return { campaign: {} };
        case NodeType.CancelTask:
            // todo: return here
            return { cancelType: null };
        case NodeType.CustomTask:
        case NodeType.Conditional:
        case NodeType.ABTest:
        case NodeType.Webhook:
        case NodeType.AssignTargetAgent:
        case NodeType.UpdateTask:
        case NodeType.Reminder:
        case NodeType.ScheduledCallback:
            return {};
        default:
            return {};
    }
}
export function createNode({ type, position }: { type: NodeType; position: XYPosition }): Node {
    const node: Node = {
        id: uuidv4(),
        type,
        position,
        data: initData(type),
    };
    return node;
}

/**
 * Generates a unique edge ID that includes sourceHandle to avoid duplicate keys
 * when multiple transitions from the same source connect to the same target.
 */
export function generateEdgeId({
    source,
    sourceHandle,
    target,
}: {
    source: string;
    sourceHandle: string | null | undefined;
    target: string;
}): string {
    return sourceHandle ? `${source}-${sourceHandle}-to-${target}` : `${source}-to-${target}`;
}

export function createEdge({
    source,
    sourceHandle,
    target,
}: {
    source: string;
    sourceHandle: string | null | undefined;
    target: string;
}): Edge {
    return {
        id: generateEdgeId({ source, sourceHandle, target }),
        source,
        sourceHandle,
        target,
        type: "buttonedge",
        markerEnd: { type: MarkerType.ArrowClosed },
    };
}
